import { render, staticRenderFns } from "./AllMaglie.vue?vue&type=template&id=2a4ee49c&scoped=true&"
import script from "./AllMaglie.vue?vue&type=script&lang=js&"
export * from "./AllMaglie.vue?vue&type=script&lang=js&"
import style0 from "./AllMaglie.vue?vue&type=style&index=0&id=2a4ee49c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ee49c",
  null
  
)

export default component.exports